export const SALES_SHARE_COLORS = ['#00e08f', '#FF0059', '#2d3136'];

export const SHARE_LABELS = {
    own: 'ownProducts',
    other: 'otherProducts',
    unknown: 'unknownProducts',
};
